import React, { useEffect, useRef, useState } from "react";
import GoogleDriveUpload from "./GoogleDriveUpload";
import "./GoogleDriveUpload.css";
import UploadFromDevice from "./UploadFromDevice";
import { useAWSS3FileUpload } from "../AWSFileUpload/AWSFilesUpload";
import UploadFromRepo from "./UploadFromRepo";
import UploadYoutubeLink, { UploadLinkModal } from "./UploadYoutubeLink";
import GenerateImageOption from "./GenerateImageOption";
import { useSelector } from "react-redux";


const FileUpload = ({
  showUploadPop,
  selectedFiles,
  setSelectedFiles,
  setuploadedFileLink,
  youtubeLinks,
  setShowUploadPop,
  fileInputRef,
  uploadFromRepo,
  setUploadFromRepo,
  setFile_list_id,
  selectedRepoFiles,
  generateImageOpen,
  defaultYoutubeLink,
  setGenerateImageOpen,
  disabled = false,
  imageOnly = false, // assignment with a lesson: show only "Generate Image"
  onYoutubeLinkSubmit = () => { },
}) => {
  const popupRef = useRef(null);


  const [openUploadRepo, setOpenUploadRepo] = useState(false);
  const [linkModalOpen, setLinkModalOpen] = useState(false);
  const globalState = useSelector((state) => state.globalState);

  const hasPicture = globalState.enabled_modules?.includes('picture_generation');
  const hasYoutube = globalState.enabled_modules?.includes('youtube_modul') && !defaultYoutubeLink.length > 0;


  const popupTop = hasPicture && hasYoutube
    ? '-240px'
    : hasPicture || hasYoutube
      ? '-200px'
      : '-160px';


  //click outside closes popup
  useEffect(() => {
    if (!showUploadPop) return;

    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowUploadPop(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showUploadPop]);

  useEffect(() => {
    if (disabled && showUploadPop) {
      setShowUploadPop(false);
    }
  }, [disabled, showUploadPop, setShowUploadPop]);

  const { handleFileChange } = useAWSS3FileUpload({
    selectedFiles,
    setSelectedFiles,
    setuploadedFileLink,
    setShowUploadPop,
    selectedRepoFiles,
  });

  if (disabled) {
    return null;
  }

  const pictureGenerationEnabled = globalState.enabled_modules?.includes('picture_generation');

  if (imageOnly) {
    // Nothing to offer if image generation isn't enabled for this school
    if (!showUploadPop || !pictureGenerationEnabled) return null;

    return (
      <div className="google-drive-popup-wrapper" style={{ top: '-72px' }}>
        <div ref={popupRef} className="google-drive-popup-container">
          <GenerateImageOption
            setShowUploadPop={setShowUploadPop}
            onOpen={() => setGenerateImageOpen(true)}
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {showUploadPop && (
        <div className="google-drive-popup-wrapper"
          style={{ top: popupTop }}
        >
          <div ref={popupRef} className="google-drive-popup-container">
            <UploadFromRepo
              setUploadFromRepo={setUploadFromRepo}
              uploadFromRepo={uploadFromRepo}
              setShowUploadPop={setShowUploadPop}
            />
            <hr className="!m-0 border-[#9d9a9a]" />
            <UploadFromDevice
              setShowUploadPop={setShowUploadPop}
              handleFileChange={handleFileChange}
              fileInputRef={fileInputRef}
            />
            <hr className="!m-0 border-[#9d9a9a]" />
            <GoogleDriveUpload
              setShowUploadPop={setShowUploadPop}
              handleFileChange={handleFileChange}
              setFile_list_id={setFile_list_id}
            />
            {
              (globalState.enabled_modules?.includes('youtube_modul') && !defaultYoutubeLink.length > 0) && (
                <>
                  <hr className="!m-0 border-[#9d9a9a]" />
                  <UploadYoutubeLink
                    setShowUploadPop={setShowUploadPop}
                    onOpen={() => setLinkModalOpen(true)} // 👈 opens the modal
                    youtubeLinks={youtubeLinks}
                  />
                </>
              )
            }

            {
              globalState.enabled_modules?.includes('picture_generation') && (
                <>
                  <hr className="!m-0 border-[#9d9a9a]" />
                  <GenerateImageOption
                    setShowUploadPop={setShowUploadPop}
                    onOpen={() => setGenerateImageOpen(true)}
                  />
                </>
              )
            }

          </div>
        </div>
      )}

      {/* 👇 mounted OUTSIDE the popup so it survives the popup unmounting */}

      {
        globalState.enabled_modules?.includes('youtube_modul') && (
          <UploadLinkModal
            open={linkModalOpen}
            onClose={() => setLinkModalOpen(false)}
            onSave={onYoutubeLinkSubmit}
          />
        )
      }

    </>
  );
};

export default FileUpload;